import { z } from 'zod';

const idDefensorSchema = z.number().int().positive().nullable().optional();

export const conselhoSuperiorFormSchema = z.object({
  id: z.number().int().positive().nullable().optional(),
  anoInicio: z.number().int().min(2000),
  anoFim: z.number().int().min(2002),
  defensorPublicoGeralId: idDefensorSchema,
  subdefensorInstitucionaisId: idDefensorSchema,
  subdefensorAdministrativosId: idDefensorSchema,
  corregedorOuvidorGeralId: idDefensorSchema,
  primeiraCategoriaIds: z.array(z.number().int().positive()).default([]),
  segundaCategoriaIds: z.array(z.number().int().positive()).default([]),
  participantesVoz: z
    .array(
      z.object({
        id: z.string().uuid(),
        nome: z.string(),
      }),
    )
    .default([]),
});

export type ConselhoSuperiorFormDto = z.infer<typeof conselhoSuperiorFormSchema>;
